import { createReducer, on } from '@ngrx/store';
import * as DeleteVmixServerActions from '../actions/delete-vmix-server.actions';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';

export const deleteVmixServerFeatureKey = 'deleteVmixServer';

export interface State {
  record: ProductionInstance | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(DeleteVmixServerActions.deleteVmixServer, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(DeleteVmixServerActions.deleteVmixServerSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(DeleteVmixServerActions.deleteVmixServerFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(DeleteVmixServerActions.clearDeleteVmixServerState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

